/**
 * システム
 */
import Repository from "../JsonRepository";
import Logger from "../../lib/logger";

const resource = "";

export default {
  /**
   * 編集系共通定義マスタ情報取得
   */
  getEdtCmn() {
    let path = "master/system/editCommon.json";

    Logger.debug("json getEdtCmn(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};
